export default "__VITE_PUBLIC_ASSET__515c23c2__"